// material-ui
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// project import
import NavGroup from './NavGroup';
import menuItems from 'menu-items';

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

export default function Navigation() {
  // ambil user dari localStorage
  const user = JSON.parse(localStorage.getItem('user'));

  // ambil role
  const role = user?.role || 'pegawai';

  // ambil menu sesuai role
   const menu = menuItems;
  // DEBUG (boleh dihapus nanti)
  console.log('ROLE:', role);
  console.log('MENU:', menuItems);

  const navGroups = menuItems.items.map((item) => {
    switch (item.type) {
      case 'group':
        return <NavGroup key={item.id} item={item} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Fix - Navigation Group
          </Typography>
        );
    }
  });

  return <Box sx={{ pt: 2 }}>{navGroups}</Box>;
}